import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { getMasterData } from '../../AddComplain/api';
import Input from '../../../components/Elements/input';
import { notiflixLoaderEnd, notiflixLoaderStart } from '../../../components/ui/notification';
import { actionNotifier } from '../../../components/ui/toast';
import { addVcReport } from './api';

const VcReport = (props) => {
    const [vcBlock, setVcBlock] = useState([])
    const [vcnode, setVcNode] = useState([])
    const [formData, setFormData] = useState({
        vcBlock: '',
        vcNode: '',
        vcNodeImage: '',
        date:''
    });
    const [imagePreviews, setImagePreviews] = useState([]);

    const getVcBlock = async (string) => {
        let data = await getMasterData(`?type=VC_NODE_BLOCK&districtName=${string}`);
        data = data.map((d) => ({
            id: d.block,
            value: d.block,
        }));
        setVcBlock(data);
    };
    const getVcNode = async (string) => {
        let data = await getMasterData(`?type=VC_NODE&blockName=${string}`);
        data = data.map((d) => ({
            id: d.id,
            value: d.complexName,
        }));
        setVcNode(data);
    };

    const handleChange = (e, fieldName) => {
        if (e.target.type === 'file') {
            const file = e.target.files[0];
            setFormData((prevState) => ({
                ...prevState,
                [fieldName]: file, // Save the selected file to the formData
            }));
            setImagePreviews([...imagePreviews, URL.createObjectURL(file)]);
        } else {
            // For regular inputs
            const value = e.target.value;
            setFormData((prevState) => ({
                ...prevState,
                [fieldName]: value,
            }));
        }
    };


    useEffect(() => {
        getVcBlock(props.auth.auth.districtName);
    }, [props.auth.auth.districtName]);

    useEffect(() => {
        getVcNode(formData.vcBlock)
    }, [formData.vcBlock])

    useEffect(() => {
        const fetchData = async () => {
            if (formData.vcNode && formData.vcNodeImage) {
                const fd = new FormData();
                // Append fields to FormData
                fd.append('complexId', formData.vcNode);
                fd.append('vcnode', formData.vcNodeImage);
                fd.append('createdAt', formData.date);
                notiflixLoaderStart();
                try {
                    let res = await addVcReport(fd);
                    if (res.status) {
                        actionNotifier.success("Submitted Successfully");
                        setFormData({
                            ...formData,
                            vcNodeImage: null,
                        });
                    } else {
                        actionNotifier.error(res.message);
                    }
                } catch (error) {
                    console.error("Error:", error);
                    actionNotifier.error("An error occurred while submitting.");
                } finally {
                    notiflixLoaderEnd();
                }
            } else {
                console.log("Something Went Wrong!! Please refresh the page");
            }
        };
        fetchData();
    }, [formData]);


    return (
        <>
            <h4 className="m-3">कृपया वी.सी की फोटो अपलोड करें </h4>
            <div className="row">
                <div className="col-md-6  m-3">
                    <Input
                        title={"कृपया प्रखंड चुने"}
                        type={"select"}
                        options={vcBlock}
                        name={"vcBlock"}
                        required={true}
                        value={formData.vcBlock}
                        onChange={(e) => handleChange(e, 'vcBlock')}
                        optionLabel={"value"}
                        optionValue={"id"}
                    />
                </div>

                {
                    formData.vcBlock &&
                    <div className="col-md-6  m-3">
                        <Input
                            title={"कृपया वी.सी नोड चुने "}
                            type={"select"}
                            options={vcnode}
                            name={"vcNode"}
                            required={true}
                            value={formData.vcNode}
                            onChange={(e) => handleChange(e, 'vcNode')}
                            optionLabel={"value"}
                            optionValue={"id"}
                        />
                    </div>
                }
                {
                    formData.vcNode &&
                    <div className="col-md-6  m-3">
                        <Input
                            title={"कृपया दिनांक चुने "}
                            type={"date"}
                            name={"date"}
                            required={true}
                            value={formData.date}
                            onChange={(e) => handleChange(e, 'date')}

                        />
                    </div>
                }
            </div>
            <div className='row'>
                {
                    formData.vcBlock && formData.vcNode && <div className="row">
                        <div className="col-md-6  m-3">
                            <p className='ml-3'>The Photo Should Be Captured through NoteCam App Only !</p>
                            <input
                                type="file"
                                name="vcNodeImage"
                                className="form-control ml-3"
                                onChange={(e) => handleChange(e, 'vcNodeImage')}
                                accept="image/png, image/gif, image/jpeg"
                            />
                        </div>
                    </div>
                }

                {imagePreviews?.map((preview, index) => (
                    <div key={index} className="row">
                        <div className="col-md-6 m-3">
                            <a href={preview} target="_blank" rel="noopener noreferrer">
                                <img src={preview} alt="Selected" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.Auth,
    };
};

export default connect(mapStateToProps)(VcReport);
